import { useState } from 'react';

export default function HeroSection() {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      window.REACT_APP_NAVIGATE(`/category/canyin-meishi?q=${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  return (
    <section className="relative w-full min-h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20golden%20amber%20and%20cream%20tones%2C%20soft%20modern%20gradient%20background%20with%20overlapping%20circles%20and%20organic%20shapes%2C%20minimalist%20clean%20design%2C%20professional%20business%20aesthetic%2C%20gentle%20warm%20light%20texture%2C%20no%20text%2C%20no%20people&width=1600&height=800&seq=hero-bg-yellow-pages&orientation=landscape"
          alt="黄页网站免费入口91 - 企业信息免费发布平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl font-bold text-white font-heading leading-tight">
          黄页网站免费入口91
        </h1>
        <p className="mt-4 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          最便捷的企业信息免费发布通道，快速收录公司名称、联系方式、经营范围等信息，助力企业提升曝光度与搜索排名
        </p>

        <form onSubmit={handleSearch} className="mt-8 max-w-xl mx-auto">
          <div className="flex items-center bg-white rounded-full shadow-lg overflow-hidden">
            <div className="pl-5 flex items-center">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-search-line text-lg text-foreground-400"></i>
              </div>
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="搜索企业名称、经营范围、关键词..."
              className="flex-1 px-3 py-4 text-sm text-foreground-800 bg-transparent outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="px-6 py-4 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索企业
            </button>
          </div>
        </form>

        <div className="mt-6 flex items-center justify-center gap-4 text-xs text-white/70 flex-wrap">
          <span>热门搜索：</span>
          <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">餐饮加盟</a>
          <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">装修公司</a>
          <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">教育培训</a>
          <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">物流公司</a>
          <a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">律师事务所</a>
        </div>
      </div>
    </section>
  );
}